import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UpdateProductWarrantyService, UpdateProductWarrantyServiceResponseModel, UpdateWarrantyServiceModel, UpdateWarrantyServiceResponseModel } from 'src/app/models/product/updateProductWarrantyService.modal';
import { ProductWarrantyServiceModel } from 'src/app/models/warrantyService/warrantyServiceListing.modal';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { WarrantyServiceService } from 'src/app/services/warranty-service.service';

@Component({
  selector: 'app-product-warranty-service',
  templateUrl: './product-warranty-service.component.html',
  styleUrls: ['./product-warranty-service.component.css']
})
export class ProductWarrantyServiceComponent implements OnInit {

  WarrantyServiceList: Array<ProductWarrantyServiceModel>;
  Loader: boolean = false;
  updateProductWarrantyService = new UpdateProductWarrantyService();
  updateProductWarrantyServiceResponseModel = new UpdateProductWarrantyServiceResponseModel;
  warrantyId: string;
  productId: string;
  selectedActiveValue: string;
  updateWarrantyServiceModel: UpdateWarrantyServiceModel = new UpdateWarrantyServiceModel();
  updateWarrantyServiceResponseModel: UpdateWarrantyServiceResponseModel;

  constructor(private router: ActivatedRoute, private route: Router, private alertify: AlertifyService, private _warrantyServiceService: WarrantyServiceService,) {
    this.updateProductWarrantyService = new UpdateProductWarrantyService();
    this.WarrantyServiceList = new Array<ProductWarrantyServiceModel>();
  }

  ngOnInit() {
    this.router.params.subscribe((param) => {
      this.productId = param.id;
    })
    this.warrantyServiceList();
  }

  warrantyServiceList() {
    this.Loader = true;
    this._warrantyServiceService.WarrantyServiceListing()
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.Loader = false;
          for (var i = 0; i < responseBody.responseData.length; i++) {
            var item = responseBody.responseData[i];
            var warrantyItem = new ProductWarrantyServiceModel();
            if (item.isActive) {
              warrantyItem.id = item.id;
              warrantyItem.title = item.title;
              warrantyItem.isSelected = false;
              this.WarrantyServiceList.push(warrantyItem);
            }
          }

          this.getWarrantyServiceProduct();
        }
        (err) => {
          this.Loader = false;
        }
      });
  }

  setSelectedWarranty(item: ProductWarrantyServiceModel, event) {
    for (var j = 0; j < this.WarrantyServiceList.length; j++) {
      if (this.WarrantyServiceList[j].id == item.id) {
        this.WarrantyServiceList[j].isSelected = !this.WarrantyServiceList[j].isSelected;
        break;
      }
    }
  }

  onSubmit() {
    this.Loader = true;
    this.updateProductWarrantyService.ProductId = this.productId;
    var warrantyServiceId = [];
    for (var j = 0; j < this.WarrantyServiceList.length; j++) {
      if (this.WarrantyServiceList[j].isSelected) {
        warrantyServiceId.push(this.WarrantyServiceList[j].id.toString());
      }
    }
    this.updateProductWarrantyService.WarrantyIds = warrantyServiceId.toString();
    this._warrantyServiceService.updateProductWarrantyService(this.updateProductWarrantyService)
      .subscribe((response) => {
        var responseBody = JSON.parse(response._body);
        this.Loader = false;
        if (responseBody.isSuccess) {
          this.alertify.success(responseBody.responseData);
        }
        else {
          this.alertify.error(responseBody.responseMessage);
        }
        this.Loader = false;
      });
  }

  getWarrantyServiceProduct() {
    this.updateWarrantyServiceModel.ProductId = +this.productId;
    this._warrantyServiceService.getProductWarrantyServiceId(this.updateWarrantyServiceModel.ProductId)
      .subscribe((response) => {
        var responseBody = JSON.parse(response._body);
        for (var i = 0; i < responseBody.responseData.length; i++) {
          var item = responseBody.responseData[i];
          for (var j = 0; j < this.WarrantyServiceList.length; j++) {
            if (this.WarrantyServiceList[j].id == item.warrantyIds) {
              this.WarrantyServiceList[j].isSelected = true;
              break;
            }
          }
        }
      });
  }

  onCancel() {
    this.route.navigate(['productListing']);
  }

  selectActive(selectedValue) {
    this.selectedActiveValue = selectedValue;
  }

}